import React from 'react';
import './classes/ConferenceSidebarBlocks.css';
import { configData } from "../config";

// Blocks the live site places in the right column of some conference pages, with their content
// typed into the block (Drupal custom blocks 133, 134 and 11). The pictures are on the Drupal site.
const files_url = configData.DRUPAL_DOMAIN_URL + '/sites/default/files/';

// Block 133: pictures of the Toronto PrimeTime conference
const PRIMETIME_PICTURES = [
    'PrimeTime Sports Management Conference.jfif',
    'PrimeTime Sports Management Conference 01.jfif',
    'PrimeTime Sports Management Conference 02.jfif',
    'PrimeTime Sports Management Conference 03.png',
    'PrimeTime Sports Management Conference 04.jfif',
    'PrimeTime Sports Management Conference 05.jfif',
    'PrimeTime Sports Management Conference 06.jfif',
];

// Block 134: pictures of the Race Track Business Conference
const RACETRACK_PICTURES = ['racetrack-right-1.jpg', 'racetrack-right-2.jpg', 'racetrack-right-3.jpg'];

// Block 11: what hockey executives say about SMWW
const HOCKEY_QUOTES = [
    {
        name: 'Brian Burke',
        roles: ['Calgary Flames GM'],
        picture: 'brain.png',
        quote: '"If you are thinking about a career in hockey, SMWW is a cutting edge program that offers you the training, skills, vital networking, mentoring, and hockey specific training that will assist you in breaking in or advancing your career in professional hockey. They have hundreds of graduates now working at all levels of the game."',
    },
    {
        name: 'Mike Johnston',
        roles: ['Portland Winterhawks GM/Head Coach', 'Former Pittsburgh Penguins Head Coach'],
        picture: 'mike.jpg',
        quote: '"SMWW is a quality organization. I personally have hired their graduates!"',
    },
    {
        name: 'EJ Hradek',
        roles: ['NHL Network'],
        picture: 'ej.jpg',
        quote: '"SMWW offers a tremendous opportunity for people to break into a career on the business side of hockey."',
    },
];

const PrimeTimePictures = () => (
    <div id="block-block-133" className="conference-sidebar-block">
        {PRIMETIME_PICTURES.map((file) => (
            <p key={file}><img src={files_url + encodeURIComponent(file)} alt="" /></p>
        ))}
    </div>
);

const RacetrackPictures = () => (
    <div id="block-block-134" className="conference-sidebar-block">
        {RACETRACK_PICTURES.map((file, idx) => (
            <React.Fragment key={file}>
                {idx > 0 && <div className="conference-sidebar-block__gap">&nbsp;</div>}
                <div><img src={files_url + file} alt="" /></div>
            </React.Fragment>
        ))}
    </div>
);

const HockeyQuotes = () => (
    <div id="block-block-11" className="conference-sidebar-block">
        {HOCKEY_QUOTES.map((person) => (
            <React.Fragment key={person.name}>
                <h2 className="conference-sidebar-block__title">
                    {person.name}<br />
                    {/* A second line of roles is smaller, inside a 15px line, as typed into the block */}
                    <span className={'conference-sidebar-block__roles' + (person.roles.length > 1 ? ' conference-sidebar-block__roles--two' : '')}>
                        {person.roles.map((role, idx) => (
                            <React.Fragment key={role}>
                                {idx > 0 && <br />}
                                <span className={idx > 0 ? 'conference-sidebar-block__role-small' : 'conference-sidebar-block__role'}>{role}</span>
                            </React.Fragment>
                        ))}
                    </span>
                </h2>
                <div className="conference-sidebar-block__quote">
                    <img src={files_url + person.picture} alt="" />
                    <p><em>{person.quote}</em></p>
                </div>
            </React.Fragment>
        ))}
    </div>
);

// Which page shows which block, and where: "top" under the quick form (at the top of the column),
// "middle" between the success stories and the testimonials
const BLOCKS = {
    893: { position: 'top', Block: PrimeTimePictures },     // /conferences/prime-time-sports-entertainment-conference
    98261: { position: 'top', Block: RacetrackPictures },   // /race-track-business-conference
    887: { position: 'middle', Block: HockeyQuotes },       // /conferences/nhl-draft-sports-career-conference
};

const ConferenceSidebarBlocks = ({ page, position }) => {
    const placed = BLOCKS[Number(page?.nid)];
    if (!placed || placed.position !== position) return null;
    return <placed.Block />;
};

export default ConferenceSidebarBlocks;
